
import { PropType, defineComponent } from 'vue'
import Menu from 'primevue/menu'
import { IKnListBoxOptions, Ibutton } from './KnListBox'

export default defineComponent({
    name: 'kn-list-button-renderer',
    components: { Menu },
    props: {
        buttons: Array as PropType<Array<Ibutton>>,
        selectedItem: Object as PropType<IKnListBoxOptions>
    },
    data() {
        return {
            filteredButtons: [] as Array<Ibutton>
        }
    },
    emits: ['click'],
    mounted() {
        this.filteredButtons = this.buttons!.filter((x) => {
            if(x.condition && x.condition.charAt(0) === "!") return !this.selectedItem?.[x.condition.substring(1,x.condition.length)]
            return !x.condition || this.selectedItem?.[x.condition]
        })
    },
    methods: {
        clickedButton(e, item) {
            e.item = item
            this.$emit('click', e)
        },
        toggleMenu(e) {
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.buttons_menu.toggle(e)
        }
    }
})
